import { useAuth } from '../../auth/AuthContext';
import { useLeaderboard, usePlatform } from '@stans-world/sdk/react';
import { registeredGameSlugs } from '../../games/gameRegistry';
import AnimatedUsdScore from './AnimatedUsdScore';

const PRIMARY_GAME_ID = registeredGameSlugs[0] || 'paper-fly';

function yourLeaderboardEntry(user, top, self) {
  if (!user) return null;
  const fromTop = top.find((r) => String(r.userId) === String(user.id));
  if (fromTop) return fromTop;
  if (self && String(self.userId) === String(user.id)) return self;
  return null;
}

function formatRank(row) {
  if (!row || typeof row.rank !== 'number' || !Number.isFinite(row.rank)) return '—';
  return `#${row.rank}`;
}

function formatCount(n) {
  if (typeof n !== 'number' || !Number.isFinite(n) || n < 0) return '—';
  return String(Math.round(n));
}

function SidebarStatsSection() {
  const { user, authChecked } = useAuth();
  const { daily, allTime } = useLeaderboard(PRIMARY_GAME_ID);
  const { primaryGame } = usePlatform();
  const gameState = primaryGame?.state ?? null;

  const dailyYou = user ? yourLeaderboardEntry(user, daily.top, daily.self) : null;
  const allTimeYou = user ? yourLeaderboardEntry(user, allTime.top, allTime.self) : null;

  const showDailyScore = Boolean(user && dailyYou != null);
  const showAllTimeScore = Boolean(user && allTimeYou != null);
  const todayRank = formatRank(dailyYou);
  const allTimeRank = formatRank(allTimeYou);

  const showRunsCount = Boolean(user && gameState?.loaded);

  const pending = !authChecked;

  return (
    <section className="stats-panel" aria-labelledby="sidebar-stats-heading">
      <div className="sidebar-divider" aria-hidden="true" />
      <h2 id="sidebar-stats-heading" className="sidebar-section-heading">
        Stats
      </h2>
      {authChecked && !user ? (
        <p className="stats-panel__hint">Sign in to track your flights and ranks.</p>
      ) : null}
      <div className={`stats-row${pending ? ' stats-row--pending' : ''}`}>
        <span className="stats-row__label">Today&apos;s best</span>
        <span className="stats-row__value">
          {pending ? '—' : showDailyScore ? <AnimatedUsdScore score={dailyYou.score} /> : '—'}
        </span>
      </div>
      <div className={`stats-row${pending ? ' stats-row--pending' : ''}`}>
        <span className="stats-row__label">Best flight</span>
        <span className="stats-row__value">
          {pending ? '—' : showAllTimeScore ? <AnimatedUsdScore score={allTimeYou.score} /> : '—'}
        </span>
      </div>
      <div className={`stats-row${pending ? ' stats-row--pending' : ''}`}>
        <span className="stats-row__label">Today&apos;s rank</span>
        <span className="stats-row__value">{pending ? '—' : todayRank}</span>
      </div>
      <div className={`stats-row${pending ? ' stats-row--pending' : ''}`}>
        <span className="stats-row__label">All-time rank</span>
        <span className="stats-row__value">{pending ? '—' : allTimeRank}</span>
      </div>
      <div className={`stats-row${pending ? ' stats-row--pending' : ''}`}>
        <span className="stats-row__label">Total flights</span>
        <span className="stats-row__value" style={{ fontVariantNumeric: 'tabular-nums' }}>
          {pending ? '—' : showRunsCount ? formatCount(gameState.runsCount) : '—'}
        </span>
      </div>
    </section>
  );
}

export default SidebarStatsSection;
